import Button from '@/components/Buttons/Button';
import { salesUrl } from '@/environment';
import { useAnalytics } from '@/services/analytics';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const styles = {
    tooltip: {
        sx: {
            backgroundColor: '#FFF',
            color: theme.colors.secondary[900],
            boxShadow:
                '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29), 2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23), 1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17), 0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12)',
            padding: '16px',
            borderRadius: '4px',
        },
    },
};

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    p {
        font-weight: 500;
        line-height: 20px;
    }

    button {
        font-weight: 600;
        font-size: 14px;
        margin-left: auto;
        padding: 7px 8px
        border-radius: 8px;
        gap: 6px;
    }
`;

export const ContactSalesTooltipContent = () => {
    const mixpanel = useAnalytics();

    const handleClick = () => {
        mixpanel?.track('contact', { event: 'click', from: 'sales' });
        window.open(salesUrl, '_blank');
    };

    return (
        <StyledContainer>
            <Typography variant="h3">Enterprise feature</Typography>
            <Typography variant="body1">Hiding “Powered by D-ID” is only available on the Enterprise plan</Typography>
            <Button color="secondary" onClick={handleClick}>
                Contact Sales
            </Button>
        </StyledContainer>
    );
};
